import React, { Component } from "react";
import { connect } from "react-redux";

import { TicketApi } from "services/ticket";
import { Permissions } from "services/permissions";
import { Utils } from "services/utils";
import { ComponentFooter } from "styled_components/Common/ComponentFooter";
import { BloxButton } from "styled_components/Common/BloxButton";
import ComponentWrapper from "sub_components/Layout/ComponentWrapper";
import { DIMENSIONS } from "services/layoutManager";
import { SERVICE_IDS } from "services/utils";
import {
  TICKET_LIST_TYPE,
  STATUS,
  TicketHistoryFiltering,
  TicketHistorySorting,
} from "utils/TicketConstants";
import { Filter } from "styled_components/Common/Filter";
import { Divider } from "styled_components/Common/Divider";
import { Sort } from "styled_components/Common/Sort";
import { SortProvider } from "context/SortContext";
import { setHomeTour } from "actions/tour";
import { FilterProvider } from "context/FilterContext";
import NewTicket from "sub_components/Common/NewTicket";
import LoadingCube from "sub_components/Common/LoadingCube";
import {
  updateModule,
  updatePage,
  addPageToBreadCrumbs,
} from "actions/siteTracking";
import { MENU as SUPPORT_MENU } from "utils/TicketConstants";
import { SITE_PAGES, SITE_MODULES } from "utils/CommonConstants";
import { JoyRideToolTip } from "styled_components/Common/JoyRideToolTip";
import BloxPage from "sub_components/Layout/BloxPage";
import ScrollView from "sub_components/Common/BloxScrollViewNew";
import { updateArrowVisibility } from "blox_components/Support/Conversations/Components/ConvoCycleAnimations";
import TicketHistoryDetail from "blox_components/Support/TicketHistoryDetail/TicketHistoryDetail";
import { RESOLUTIONS } from "services/config";
import { updatePermissions } from "actions/permissions";
import Joyride from "react-joyride-react-19";
import { getUserPermissions, setUserPermissions } from "services/user";

const PAGE_STATE = {
  LIST: "LIST",
  DETAIL: "DETAIL",
};

const LAYOUT_CONFIG_LIST = {
  [RESOLUTIONS.LOW]: {
    tickets: { x: 0, y: 1, dim: DIMENSIONS.TEN_BY_TEN },
    tourButton: { x: 0, y: 100, dim: DIMENSIONS.TWO_BY_TWO },
  },
  [RESOLUTIONS.MED]: {
    tickets: { x: 0, y: 1, dim: DIMENSIONS.TEN_BY_TEN },
    tourButton: { x: 0, y: 100, dim: DIMENSIONS.TWO_BY_TWO },
  },
  [RESOLUTIONS.HIGH]: {
    tickets: { x: 0, y: 1, dim: DIMENSIONS.TEN_BY_TEN },
    tourButton: { x: 0, y: 100, dim: DIMENSIONS.TWO_BY_TWO },
  },
};

class TicketHistory extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: null,
      topItem: 0,
      currentItem: 0,
      showBottomArrow: false,
      showTopArrow: false,
      selected: "Any",
      selectedTicketStatus: "Any",
      downCount: 0,
      upCount: 0,
      topRow: 0,
      rowCount: 0,
      filterArrow: "Ascending",
      closedTickets: "",
      openTickets: "",
      tickets: [],
      filteredTickets: "",
      pageState: PAGE_STATE.LIST,
      selectedTicketId: null,
      filterTitle: "Any",
      rowHeight: 0,
      margin: [],
      containerPadding: [],
      layout: [],
      users: null,
      pages: null,
      selectedView: "user",
      role: "",
      loading: true,
      page: 1,
      ticketType: null,
      ticketRequestType: null,
    };
  }
  componentWillUnmount() {
    Utils.addScroll();
  }

  componentDidUpdate(prevProps) {
    const { pageState, selectedTicket } = this.state;
    const {
      match,
      company_info: { customer: { id } = {} },
    } = this.props;
    const pathname = window.location.pathname;
    const matches = pathname.split("/");

    const { updatePage, addPageToBreadCrumbs } = this.props;

    if (matches) {
      const [, , , , , ticketNumber] = matches;

      if (ticketNumber && pageState === PAGE_STATE.LIST) {
        Utils.addScroll();
        this.setState({ pageState: PAGE_STATE.DETAIL, selectedView: "user" });
      } else if (!ticketNumber && pageState === PAGE_STATE.DETAIL) {
        updatePage(SITE_PAGES.SUPPORT[SUPPORT_MENU.TICKET_HISTORY]);
        addPageToBreadCrumbs(
          SITE_PAGES.SUPPORT[SUPPORT_MENU.TICKET_HISTORY],
          SITE_MODULES.SUPPORT
        );
        Utils.removeScroll();
        this.setState({ pageState: PAGE_STATE.LIST, selectedView: "user" });
      } else if (
        ticketNumber &&
        pageState === PAGE_STATE.DETAIL &&
        !selectedTicket
      ) {
        this.updatePage();
      }
    }

    if (prevProps.match !== match) {
      this.updatePage();
    }
    if (prevProps.company_info?.customer?.id !== id) {
      this.getUsersRole(id);
    }
  }
  getModulePages = async () => {
    const {
      updatePermissions,
      auth_status: {
        user: { id: userId },
      },
      company_info: {
        customer: { id: orgId },
      },
    } = this.props;

    const permissions = getUserPermissions("support");
    if (!permissions) {
      const response = await Permissions.getModulePermissions(2, userId, orgId);
      if (response && !response.data.error) {
        setUserPermissions("support", response.data.pages);
        updatePermissions(response.data.pages);
        this.setState({
          loaded: true,
        });
      }
    } else {
      updatePermissions(permissions);
    }
  };

  closeTour = (joyride) => {
    const { setHomeTour } = this.props;

    const action = joyride?.action;
    if (action === "close" || action === "reset" || action === "stop") {
      setHomeTour({ runHomeTour: false, action });
    }
  };

  setShowTopArrow = (showTopArrow) => {
    this.setState({ showTopArrow });
  };

  setShowBottomArrow = (showBottomArrow) => {
    this.setState({ showBottomArrow });
  };
  getTicketId = () => {
    const { pathname } = window.location;
    const matches = pathname.split("/");

    if (matches) {
      const [, , , , ticketRequestType, ticketNumber] = matches;

      if (ticketNumber) {
        this.setState({ selectedTicket: true, ticketRequestType });
        return ticketNumber;
      }
    }
  };

  updatePage = () => {
    const { selected } = this.props;
    const { ticketType } = this.state;
    const id = this.getTicketId();

    if (id) {
      this.setState({
        pageState: PAGE_STATE.DETAIL,
        selectedTicketId: id,
      });
    } else {
      if (ticketType?.bonita) {
        this.getTickets();
      }
    }
    if (selected) {
      this.setState({ selected });
    }
  };
  checkParams = async () => {
    const {
      location: { state },
    } = this.props;
    const { ticketType } = this.state;

    if (state) {
      this.setState(
        { selectedTicketStatus: state.status, selected: state.type },
        () => {
          if (ticketType?.bonita) {
            this.getTickets();
          }
        }
      );
    } else {
      if (ticketType?.bonita) {
        this.getTickets();
      }
    }
  };

  componentDidMount() {
    const {
      updateModule,
      updatePage,
      addPageToBreadCrumbs,
      company_info: { customer: { id } = {} },
      site,
      permissions,
      location,
      setHomeTour,
    } = this.props;
    const search = location?.search;

    if (search.includes("tour=true")) {
      setHomeTour({ runHomeTour: true, action: "start" });
    }

    updatePage(SITE_PAGES.SUPPORT[SUPPORT_MENU.TICKET_HISTORY]);
    addPageToBreadCrumbs(
      SITE_PAGES.SUPPORT[SUPPORT_MENU.TICKET_HISTORY],
      SITE_MODULES.SUPPORT
    );

    if (site?.module !== "SUPPORT" || !permissions?.permissions) {
      this.getModulePages();
    }
    this.getTicketType("support");
    updateModule(SITE_MODULES.SUPPORT);
    Utils.removeScroll();
    this.getUsersRole(id);

    updateArrowVisibility(
      this.setShowTopArrow,
      this.setShowBottomArrow,
      ".ticket-history-ticket-row",
      ".ticket-history-row"
    );
  }

  displayTicketHistory = () => {
    const { navigate } = this.props;

    navigate("/portal/support");
  };

  onSelectTicket = (ticket) => {
    const { addPageToBreadCrumbs, updatePage, navigate } = this.props;
    const ticketType = "support";
    const url = `/portal/support/ticket_history/support/${ticket.id}`;

    updatePage(SITE_PAGES.SUPPORT[SUPPORT_MENU.TICKET_HISTORY_DETAIL]);
    addPageToBreadCrumbs(`TICKET #${ticket.id}`, SITE_MODULES.SUPPORT, url);

    navigate(url);

    this.setState({
      pageState: PAGE_STATE.DETAIL,
      selectedTicketId: ticket.id,
      ticketRequestType: ticketType,
    });
  };

  getTicketType = (type) => {
    return TicketApi.getTicketType(type)
      .then((response) => {
        if (response.status === 200 && response?.data && !response.data.error) {
          this.setState({ ticketType: response?.data }, () =>
            this.checkParams()
          );
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getDisplayTickets = () => {
    const { selectedTicketStatus, selected, tickets } = this.state;
    let displayTickets = tickets;
    if (
      (selectedTicketStatus && selectedTicketStatus.includes("Open")) ||
      (selectedTicketStatus && selectedTicketStatus.includes("open"))
    ) {
      displayTickets = tickets.filter(
        (ticket) =>
          !["closed", "solved"].includes(ticket?.status?.toLowerCase())
      );
    } else if (
      (selectedTicketStatus && selectedTicketStatus.includes("Closed")) ||
      (selectedTicketStatus && selectedTicketStatus.includes("closed"))
    ) {
      displayTickets = tickets.filter((ticket) =>
        ["closed", "solved"].includes(ticket?.status?.toLowerCase())
      );
    }
    if (
      selected &&
      !selected.includes("Any") &&
      selected &&
      !selected.includes("general") &&
      selected &&
      !selected.includes("General") &&
      selected &&
      !selected.includes("any")
    ) {
      displayTickets = displayTickets.filter((ticket) =>
        ticket.name.toLowerCase().includes(selected)
      );
    }

    return displayTickets;
  };

  getFilterTickets = () => {
    const { rowCount } = this.state;
    const { selectedTicket } = this.props;
    const list = [];
    let row = 0;
    const displayTickets = this.getDisplayTickets();

    if (displayTickets && displayTickets.length) {
      for (let i = 0; i < displayTickets.length; i += 4) {
        list.push(
          <div
            key={`row-${displayTickets[i].id}-${displayTickets[i].name}`}
            className={`ticket-history-ticket-row row-${row}`}
            data-row={row}
          >
            {displayTickets[i] && (
              <NewTicket
                id={`ticket-${displayTickets[i].id}-${displayTickets[i].name}`}
                ticket={displayTickets[i]}
                active={
                  selectedTicket && displayTickets[i].id === selectedTicket.id
                }
                clickHandler={this.onSelectTicket}
                selector={i}
              />
            )}
            {displayTickets[i + 1] && (
              <NewTicket
                id={`ticket-${displayTickets[i + 1].id}-${
                  displayTickets[i].name
                }`}
                ticket={displayTickets[i + 1]}
                active={
                  selectedTicket &&
                  displayTickets[i + 1].id === selectedTicket.id
                }
                clickHandler={this.onSelectTicket}
                selector={i + 1}
              />
            )}
            {displayTickets[i + 2] && (
              <NewTicket
                id={`ticket-${displayTickets[i + 2].id}-${
                  displayTickets[i].name
                }`}
                ticket={displayTickets[i + 2]}
                active={
                  selectedTicket &&
                  displayTickets[i + 2].id === selectedTicket.id
                }
                clickHandler={this.onSelectTicket}
                selector={i + 2}
              />
            )}
            {displayTickets[i + 3] && (
              <NewTicket
                id={`ticket-${displayTickets[i + 3].id}-${
                  displayTickets[i].name
                }`}
                ticket={displayTickets[i + 3]}
                active={
                  selectedTicket &&
                  displayTickets[i + 3].id === selectedTicket.id
                }
                clickHandler={this.onSelectTicket}
                selector={i + 3}
              />
            )}
          </div>
        );
        //eslint-disable-next-line
        row++;
      }
      if (rowCount !== list.length) {
        this.setState({ rowCount: list.length });
      }

      return list;
    }
  };
  renderTickets(type) {
    const { tickets } = this.state;

    return (
      <div className={`${type}-section`}>
        <div
          className={`ticket-history-row ${
            tickets.length === 0 ? "empty" : ""
          }`}
        >
          {tickets.length === 0 && (
            <div className="no-tickets body10">No tickets to display.</div>
          )}
          {this.getFilterTickets()}
        </div>
      </div>
    );
  }

  checkAlert = () => {
    try {
      const alert = document.getElementById("alert-banner-container");
      const downArrow = document.querySelector(".ticket-history-down-arrow");

      if (alert && downArrow) {
        downArrow.classList.add("alert-present");
      } else if (downArrow) {
        downArrow.classList.remove("alert-present");
      }
    } catch (error) {
      console.log(error);
    }
  };

  checkTicketPermissions = (tickets) => {
    const { permissions: pages } = this.props;
    const {
      auth_status,
      company_info: { customer: { id } = {} },
    } = this.props;
    const { memberships } = auth_status;
    const { access: hasBillingAccess } = Permissions.hasService(
      memberships,
      "Billing",
      id
    );
    const ViewGuestAccess = Permissions.checkComponentAccess(
      pages,
      "Ticket History",
      "view-guest-access"
    );
    const ViewRemoteHands = Permissions.checkComponentAccess(
      pages,
      "Ticket History",
      "view-remote-hands"
    );
    const ViewSupportGeneral = Permissions.checkComponentAccess(
      pages,
      "Ticket History",
      "view-support-general"
    );
    const ViewSupportBilling = Permissions.checkComponentAccess(
      pages,
      "Ticket History",
      "view-support-billing"
    );
    const ViewSupportOutage = Permissions.checkComponentAccess(
      pages,
      "Ticket History",
      "view-support-outage"
    );
    const ViewSupportStorage = Permissions.checkComponentAccess(
      pages,
      "Ticket History",
      "view-support-storage"
    );

    const hasViewAllMyTicketsAccess = Permissions.checkComponentAccess(
      pages,
      "Ticket History",
      "view-my-tickets"
    );

    let filteredTickets = tickets;

    filteredTickets = hasBillingAccess
      ? filteredTickets
      : tickets.filter((ticket) => ticket.type.toLowerCase() !== "billing");

    filteredTickets = ViewGuestAccess
      ? filteredTickets
      : filteredTickets.filter(
          (ticket) => ticket.type.toLowerCase() !== "guest access"
        );

    filteredTickets = ViewRemoteHands
      ? filteredTickets
      : filteredTickets.filter(
          (ticket) => ticket.type.toLowerCase() !== "remote hands"
        );

    filteredTickets = ViewSupportGeneral
      ? filteredTickets
      : filteredTickets.filter(
          (ticket) =>
            ticket.type.toLowerCase() !== "support" &&
            ticket.type.toLowerCase() !== "feedback" &&
            ticket.type.toLowerCase() !== "roster-add-access" &&
            ticket.type.toLowerCase() !== "roster-del-access"
        );

    filteredTickets = ViewSupportOutage
      ? filteredTickets
      : filteredTickets.filter(
          (ticket) => ticket.type.toLowerCase() !== "outage"
        );

    filteredTickets = ViewSupportBilling
      ? filteredTickets
      : filteredTickets.filter(
          (ticket) => ticket.type.toLowerCase() !== "billing"
        );

    filteredTickets = ViewSupportStorage
      ? filteredTickets
      : filteredTickets.filter(
          (ticket) => ticket.type.toLowerCase() !== "storage"
        );

    if (hasViewAllMyTicketsAccess) {
      return filteredTickets;
    } else {
      return [];
    }
  };

  splitTickets(tickets) {
    if (!tickets) return null;
    const filteredTickets = this.checkTicketPermissions(tickets);

    const open = filteredTickets.filter(
      (ticket) =>
        ticket.status !== STATUS.SOLVED &&
        ticket.status !== STATUS.RESOLVED &&
        ticket.status !== STATUS.CLOSED
    );

    const closed = filteredTickets.filter(
      (ticket) =>
        ticket.status === STATUS.SOLVED ||
        ticket.status === STATUS.RESOLVED ||
        ticket.status === STATUS.CLOSED
    );

    return { open, closed };
  }

  ticketType = (option) => {
    const { selectedView, ticketType } = this.state;
    if (ticketType?.bonita) {
      this.setState(
        {
          selected: option.toLowerCase(),
          page: 1,
          tickets: [],
          loading: true,
        },
        () => {
          if (selectedView === "org") {
            if (ticketType?.bonita) {
              this.getAllOrgTickets();
            }
          } else {
            if (ticketType?.bonita) {
              this.getTickets();
            }
          }
        }
      );
    }
  };

  getUsersRole = (id) => {
    const { auth_status } = this.props;
    const { memberships = {} } = auth_status;
    const currentMembershipSelected = memberships.filter(
      (membership) => Number(membership.organizationId) === Number(id)
    );

    this.setState({ role: currentMembershipSelected[0]?.role });
  };

  getTickets = async () => {
    const { page, selectedTicketStatus: status, selected: type } = this.state;
    const {
      company_info: {
        customer: { id },
      },
    } = this.props;

    const cachedTicketsString = sessionStorage.getItem("tickets");
    let cachedTickets = null;

    if (cachedTicketsString) {
      try {
        cachedTickets = JSON.parse(cachedTicketsString);
        if (
          cachedTickets &&
          cachedTickets.orgId === id &&
          cachedTickets.type === type &&
          cachedTickets.status === status &&
          cachedTickets.page >= page
        ) {
          this.setState({
            tickets: cachedTickets.tickets,
            loading: false,
          });
          return;
        }
      } catch (error) {
        console.error("Error parsing cached tickets:", error);
      }
    }

    let typeToSend = type;
    if (type === "general" || type === "General") {
      typeToSend = "support";
    }

    try {
      const response = await TicketApi.getAll(
        page,
        typeToSend,
        status,
        null,
        id
      );
      const validResponse = response.tickets;

      if (validResponse) {
        const newTickets = response.tickets;
        const { tickets } = this.state;
        const updatedTickets = Utils.sort(tickets.concat(newTickets));

        const ticketsCache = {
          tickets: updatedTickets,
          orgId: id,
          type: type,
          status: status,
          page: page,
          timestamp: new Date().getTime(),
        };

        sessionStorage.setItem("tickets", JSON.stringify(ticketsCache));

        this.setState({
          tickets: updatedTickets,
          loading: false,
        });
      } else {
        this.setState({
          error: "Error pulling ticket details",
          loading: false,
        });
      }
    } catch (error) {
      console.log(error);
      this.setState({ error, loading: false });
    }
  };
  getAllOrgTickets() {
    const { page, selectedTicketStatus: status, selected: type } = this.state;
    const {
      company_info: {
        customer: { id },
      },
    } = this.props;
    let typeToSend = type;
    if (type === "general" || type === "General") {
      typeToSend = "support";
    }
    TicketApi.getAll(page, typeToSend, status, "all", id)
      .then((response) => {
        const validResponse = response.tickets;
        if (validResponse) {
          const { tickets } = this.state;
          const splitTickets = this.splitTickets(response.tickets);
          const displayTickets = splitTickets.open.concat(splitTickets.closed);
          this.setState({
            tickets:
              page === 1
                ? Utils.sort(displayTickets)
                : Utils.sort(tickets.concat(displayTickets)),
            //eslint-disable-next-line
            closedTickets: splitTickets["closed"],
            filteredTickets: splitTickets,
            loading: false,
          });
        } else {
          this.setState({
            error: "Error pulling ticket details",
            loading: false,
          });
        }
      })
      .catch((error) => this.setState({ error, loading: false }));
  }

  goToNextModule = () => {
    const { location, navigate } = this.props;
    const moduleOrder = location?.state?.moduleOrder;

    if (moduleOrder && moduleOrder.length !== 0) {
      const currentIndex = moduleOrder.indexOf(2);
      const nextIndex = moduleOrder[currentIndex + 1];

      if (nextIndex) {
        const nextModule = SERVICE_IDS[nextIndex];
        const url = `/portal`;
        navigate(url, { state: { nextModule, moduleOrder } });
      }
    }
  };

  getSize = (breakpoint) => {
    let size = "medium";
    if (breakpoint === RESOLUTIONS.MED) {
      size = "medium";
    } else if (breakpoint === RESOLUTIONS.HIGH) {
      size = "medium";
    }

    return size;
  };

  updateSelectedView = (view) => {
    const { ticketType } = this.state;
    if (view === "org") {
      this.setState(
        { selectedView: view, filteredTickets: [], loading: true, page: 1 },
        () => {
          if (ticketType?.bonita) {
            this.getAllOrgTickets();
          }
        }
      );
    } else {
      this.setState(
        { selectedView: view, filteredTickets: [], loading: true, page: 1 },
        () => {
          if (ticketType?.bonita) {
            this.getTickets();
          }
        }
      );
    }
  };

  hasNextModule = () => {
    const { location } = this.props;
    const moduleOrder = location?.state?.moduleOrder;

    if (moduleOrder && moduleOrder.length !== 0) {
      const currentIndex = moduleOrder.indexOf(2);
      const nextIndex = moduleOrder[currentIndex + 1];

      if (!nextIndex) {
        return false;
      } else {
        return true;
      }
    }
  };

  updateSort = (selected) => {
    const { selectedView, ticketType } = this.state;
    const selectedSort = selected?.displayValue;
    this.setState({ selectedTicketStatus: selectedSort.toLowerCase() });
    if (ticketType?.bonita) {
      this.setState({ page: 1, tickets: [], loading: true }, () => {
        if (selectedView === "org") {
          if (ticketType?.bonita) {
            this.getAllOrgTickets();
          }
        } else {
          if (ticketType?.bonita) {
            this.getTickets();
          }
        }
      });
    }
  };

  onScrollStop = (scrollTop) => {
    const { page, selectedView, ticketType } = this.state;

    if (scrollTop > page * 400 && scrollTop !== 0) {
      this.setState({ page: page + 1 }, () => {
        if (selectedView === "org") {
          if (ticketType?.bonita) {
            //this.getAllOrgTickets();
          }
        } else {
          if (ticketType?.bonita) {
            //this.getTickets();
          }
        }
      });
    }
  };

  getComponentFooter = (
    selectedView,
    hasViewAllOrgTicketsAccess,
    breakpoint
  ) => {
    return (
      <ComponentFooter
        cypressId="notifications-footer"
        id="notifications-footer"
        buttonText1={"Your tickets"}
        buttonText2={"All tickets"}
        buttonActive1={true}
        customClassButton1={
          selectedView === "user" ? "buttons41 selected" : "buttons41"
        }
        customClassButton2={
          selectedView === "org" ? "buttons41 selected" : "buttons41"
        }
        buttonActive2={true}
        module="support"
        buttonFunction1={
          hasViewAllOrgTicketsAccess
            ? () => {
                this.updateSelectedView("user");
              }
            : null
        }
        size={this.getSize(breakpoint)}
        buttonFunction2={
          hasViewAllOrgTicketsAccess
            ? () => {
                this.updateSelectedView("org");
              }
            : null
        }
      />
    );
  };

  render() {
    const {
      setModalContent,
      breakpoint,
      auth_status,
      location,
      company_info,
      site,
      tour: { runHomeTour: { runHomeTour } } = {},
      auth_status: {
        user: { id: userId },
      },
      navigate,
    } = this.props;

    const {
      pageState,
      selectedTicketId,
      selectedView,
      loading,
      selected,
      selectedTicketStatus,
      ticketType,
      ticketRequestType,
    } = this.state;

    const { permissions: pages } = this.props || {};
    const module = site?.module;
    // const showCommentSection =
    // 	(selectedTicketId && selectedTicketId.includes('SHP')) ||
    // 	(selectedTicketId && selectedTicketId.includes('SDO'))
    // 		? false
    // 		: true;

    const hasViewAllOrgTicketsAccess = Permissions.checkComponentAccess(
      pages,
      "Ticket History",
      "view-all-account-tickets"
    );

    setTimeout(() => {
      this.checkAlert();
    }, 1000);

    const steps = [
      {
        content:
          "On this ticket history page, you are able to see your past and current support requests. Also, you are able to communicate with the assigned DC BLOX support technician working the ticket.",
        customNextButton: this.hasNextModule() ? (
          <BloxButton
            className="buttons41"
            id="continue-tour"
            text="CONTINUE"
            module="support"
            enabled={true}
            onClick={this.goToNextModule}
            cypressId="continue-tour"
          />
        ) : null,
        target: ".header-section",
        locale: { next: "Finish" },
        placement: "center",
        module: "support",
      },
    ];

    return (
      <>
        {pageState === PAGE_STATE.LIST && (
          <BloxPage
            name="page ticket-history-page"
            layout={LAYOUT_CONFIG_LIST[breakpoint]}
            breakpoint={breakpoint}
            location={location}
            setModalContent={setModalContent}
          >
            <div key={`tourButton`} className="tourButton">
              {pages && (
                <Joyride
                  steps={steps}
                  continuous={true}
                  tooltipComponent={JoyRideToolTip}
                  run={runHomeTour}
                  styles={{
                    options: {
                      zIndex: 5000,
                    },
                  }}
                  module={module}
                  callback={this.closeTour}
                  spotlightPadding={5}
                  disableScrolling={true}
                  disableBeacon={true}
                  disableOverlayClose={true}
                />
              )}
            </div>

            <div key={`tickets`} className="tickets">
              {pageState === PAGE_STATE.LIST && (
                <ComponentWrapper title="" hideBorder>
                  <div className="tickets-container">
                    <Divider />
                    <FilterProvider>
                      <Filter
                        module="support"
                        selected={selected}
                        options={TicketHistoryFiltering}
                        callback={this.ticketType}
                        filterHeading="Ticket Type"
                      />
                    </FilterProvider>
                    <SortProvider>
                      <Sort
                        module="support"
                        selected={{
                          displayValue: selectedTicketStatus,
                          value: 0,
                        }}
                        options={TicketHistorySorting}
                        callback={this.updateSort}
                        filterHeading="Ticket Status"
                      />
                    </SortProvider>
                    <div className="open-tickets">
                      <ScrollView onScrollStop={this.onScrollStop}>
                        {!loading && this.renderTickets(TICKET_LIST_TYPE.OPEN)}
                      </ScrollView>
                      {loading && <LoadingCube />}
                    </div>
                    {this.getComponentFooter(
                      selectedView,
                      hasViewAllOrgTicketsAccess,
                      breakpoint
                    )}
                  </div>
                </ComponentWrapper>
              )}
            </div>
          </BloxPage>
        )}
        {pageState === PAGE_STATE.DETAIL && selectedTicketId && (
          <TicketHistoryDetail
            id={selectedTicketId}
            ticketRequestType={ticketRequestType}
            userId={userId}
            breakpoint={breakpoint}
            setModalContent={setModalContent}
            displayTicketHistory={this.displayTicketHistory}
            pages={pages}
            navigate={navigate}
            company_info={company_info}
            auth_status={auth_status}
            ticketType={ticketType}
            runHomeTour={runHomeTour}
            setHomeTour={setHomeTour}
            module={module}
            location={location}
          />
        )}
      </>
    );
  }
}
function mapStateToProps(state) {
  return {
    auth_status: state.auth_status,
    site: state.site_tracking,
    company_info: state.company_info,
    permissions: state.permissions,
    tour: state.tours,
  };
}

export default connect(mapStateToProps, {
  updateModule,
  updatePage,
  addPageToBreadCrumbs,
  updatePermissions,
  setHomeTour,
})(TicketHistory);
